import { NavLink } from 'react-router-dom';
import clsx from 'clsx';
import { Lock } from 'lucide-react';
import { useEntitlements } from '../../hooks/useEntitlements';

export interface SubNavItem {
  to: string;
  icon: React.ElementType;
  label: string;
  gate?: string;
  isLive?: boolean;
  isEnd?: boolean; // pass end prop to NavLink (for exact-match active state)
}

interface SportSubNavProps {
  items: SubNavItem[];
  liveCount?: number;
}

export function SportSubNav({ items, liveCount = 0 }: SportSubNavProps) {
  const { canUseFeature } = useEntitlements();

  return (
    <div className="flex items-center px-4 border-b border-surface-4 bg-surface-1 flex-shrink-0 overflow-x-auto">
      <nav className="flex items-center gap-0 -mb-px">
        {items.map((item) => {
          const { to, icon: Icon, label, gate, isLive, isEnd } = item;
          const locked = gate ? !canUseFeature(gate as 'simulator' | 'backtesting') : false;
          const destination = locked ? '/settings/billing' : to;

          return (
            <NavLink
              key={to}
              to={destination}
              end={isEnd}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-1.5 px-3 py-3 text-xs font-medium border-b-2 transition-colors whitespace-nowrap flex-shrink-0',
                  locked
                    ? 'border-transparent text-gray-600 cursor-pointer'
                    : isActive
                      ? 'border-brand text-brand'
                      : 'border-transparent text-gray-400 hover:text-gray-200 hover:border-surface-4',
                )
              }
            >
              <Icon className="w-3 h-3 flex-shrink-0" />
              {label}
              {locked && <Lock className="w-2.5 h-2.5 text-gray-600 flex-shrink-0" />}
              {isLive && liveCount > 0 && !locked && (
                <span className="w-1.5 h-1.5 rounded-full bg-win animate-pulse-slow flex-shrink-0" />
              )}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
}
